(function () {
  function uniq(arr) {
    return Array.from(new Set(arr.filter(Boolean)));
  }

  function splitUrls(s) {
    return (s || "")
      .split(",")
      .map((x) => x.trim())
      .filter(Boolean);
  }

  function setUrls(hiddenInput, filesCountDiv, urls) {
    const clean = uniq(urls);
    if (hiddenInput) hiddenInput.value = clean.join(", ");
    if (filesCountDiv) {
      filesCountDiv.textContent =
        clean.length === 0
          ? ""
          : clean.length === 1
          ? "1 file uploaded"
          : clean.length + " files uploaded";
    }
  }

  // Robust extraction for different payload shapes
  function extractUrls(detail) {
    const urls = [];
    if (!detail) return urls;

    // arrays in possible fields
    const candidates = []
      .concat(detail.successEntries || [])
      .concat(detail.entries || [])
      .concat(detail.items || [])
      .concat(detail.files || [])
      .concat(detail.successFiles || []);

    for (const c of candidates) {
      if (!c) continue;
      if (typeof c === "string") {
        if (c.includes("ucarecdn.com")) urls.push(c);
      } else {
        if (c.cdnUrl) urls.push(c.cdnUrl);
        else if (c.cdn_url) urls.push(c.cdn_url);
        else if (c.fileInfo && c.fileInfo.cdnUrl) urls.push(c.fileInfo.cdnUrl);
        else if (c.data && c.data.cdnUrl) urls.push(c.data.cdnUrl);
      }
    }

    // single item shape
    if (detail.cdnUrl) urls.push(detail.cdnUrl);

    return uniq(urls);
  }

  document.addEventListener("DOMContentLoaded", function () {
    // We support multiple forms on a page, but typically there is one
    document.querySelectorAll("form[id]").forEach(function (form) {
      const ctxProvider = form.querySelector(
        "uc-upload-ctx-provider[ctx-name='my-uploader']"
      );
      const hiddenInput = form.querySelector("#uploadcare-file");
      const filesCountDiv = form.querySelector("#uploaded-files-count");

      if (!ctxProvider || !hiddenInput) return;

      ctxProvider.addEventListener("common-upload-success", function (e) {
        const urls = extractUrls(e.detail);

        // append to existing
        const existing = splitUrls(hiddenInput.value);
        const merged = uniq(existing.concat(urls));
        setUrls(hiddenInput, filesCountDiv, merged);
      });

      // Optional clear event (depends on component)
      ctxProvider.addEventListener("common-upload-clear", function () {
        setUrls(hiddenInput, filesCountDiv, []);
      });

      // Before submit: append links to message textarea
      form.addEventListener(
        "submit",
        function (e) {
          const urls = splitUrls(hiddenInput.value);

          // If you want to enforce required upload, uncomment:
          // if (urls.length === 0) {
          //   e.preventDefault();
          //   alert("Please upload at least one file/video.");
          //   return false;
          // }

          const message =
            form.querySelector('textarea[name="contact[message]"]') ||
            form.querySelector('textarea[name="contact[body]"]') ||
            form.querySelector("textarea");

          if (message && urls.length) {
            if (!message.value.includes("Uploadcare links:")) {
              message.value +=
                "\n\nUploadcare links:\n" +
                urls.map((u) => "- " + u).join("\n") +
                "\n";
            }
          }
        },
        true
      );
    });
  });
})();
  